import { createActionGroup, props } from '@ngrx/store';

/**
 * NgRx Actions for the Database module.
 * Used for managing state related to project models, data cards, and templates.
 */
export const DatabaseActions = createActionGroup({
  source: 'Database',
  events: {
    'Set Data Card Template': props<{
      projectModelName: string;
      template: string;
    }>(),
  },
});
